import React, { useEffect, useState } from "react";
import contact from "../../images/Icons/customer.png";
import { useDispatch, useSelector } from "react-redux";
import { fetchWebSetup } from "../../redux/slice/webSetup";
import { toast } from "react-toastify";
import axios from "axios";
import config from "../../config";
import Loader from "../../Component/Loader";

export default function ContactUs() {
  const dispatch = useDispatch();
  const { webSetupData, isError } = useSelector((state) => state.webSetup);
  useEffect(() => {
    if (!isError) {
      dispatch(fetchWebSetup());
    }
  }, [dispatch, isError]);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    message: "",
  });

  const [error, setError] = useState({
    nameError: "",
    phoneError: "",
  });
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateForm = () => {
    const newError = {};

    if (!formData.name) {
      newError.nameError = "Please enter your full name";
    }
    if (
      !formData.phone ||
      formData.phone.length !== 10 ||
      isNaN(formData.phone)
    ) {
      newError.phoneError = "Please enter a valid phone number";
    }
    setError(newError);
    return Object.keys(newError).length === 0;
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      try {
        const response = await axios.post(`${config.apiUrl}/contact-us`, {
          name: formData.name,
          phone: formData.phone,
          email: formData.email,
          message: formData.message,
        });

        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        resetData();
      } catch (error) {
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 2000);
      }
    }
  };
  const resetData = () => {
    setFormData({
      name: "",
      phone: "",
      email: "",
      message: "",
    });
    setError({
      nameError: "",
      phoneError: "",
    });
  };

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            <div className="row-hd-txt">
              <div className="row-hd-txt-left">
                <img src={contact} alt="icon" />
                <h5>Contact Us</h5>
              </div>
            </div>
            <div className="row g-3 mt-1">
              <div className="col-lg-7">
                <form onSubmit={handleFormSubmit} className="contact_form">
                  <div className="row g-lg-4 g-3">
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="name">
                        Your Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter your name"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleFormChange}
                      />
                      {error.nameError && (
                        <span className="input-error"> {error.nameError} </span>
                      )}
                    </div>
                    <div className="col-lg-6">
                      <label className="form-label" htmlFor="phone">
                        Phone Number
                      </label>
                      <input
                        type="number"
                        className="form-control"
                        onWheel={(e) => e.target.blur()}
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleFormChange}
                        placeholder="Enter your phone number"
                      />
                      {error.phoneError && (
                        <span className="input-error">
                          {" "}
                          {error.phoneError}{" "}
                        </span>
                      )}
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label" htmlFor="email">
                        Email Address
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleFormChange}
                        placeholder="Enter your email address"
                      />
                    </div>
                    <div className="col-lg-12">
                      <label className="form-label" htmlFor="message">
                        Your Message
                      </label>
                      <textarea
                        className="form-control"
                        id="message"
                        rows={5}
                        name="message"
                        value={formData.message}
                        onChange={handleFormChange}
                        placeholder="Enter your message"
                      />
                    </div>
                    <div className="col-lg-12">
                      <button
                        type="submit"
                        className="btn btn-success w-100 rounded"
                        disabled={loading}
                      >
                        {loading ? <Loader /> : "Submit"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="col-lg-5">
                <div className="contact-col">
                  <h2>Get In Touch</h2>
                  <h4>Registerd Office</h4>
                  <div>
                    <h5>Biznie Tradetech LLP</h5>
                    <p>{webSetupData.address}</p>
                  </div>
                  <h5>Contact Info</h5>
                  <ul>
                    {webSetupData.phone1 && (
                      <li>
                        <a href={`tel:+91${webSetupData.phone1}`}>
                          <div className="icon">
                            <i className="bi bi-telephone"></i>
                          </div>
                          <span className="txt">+91 {webSetupData.phone1}</span>
                        </a>
                      </li>
                    )}
                    {webSetupData.phone2 && (
                      <li>
                        <a href={`tel:+91${webSetupData.phone2}`}>
                          <div className="icon">
                            <i className="bi bi-telephone"></i>
                          </div>
                          <span className="txt">+91 {webSetupData.phone2}</span>
                        </a>
                      </li>
                    )}
                    {webSetupData.whatsapp && (
                      <li>
                        <a
                          href={`https://api.whatsapp.com/send?phone=+91${webSetupData.whatsapp}&text=Hello Biznie`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <div className="icon">
                            <i className="bi bi-whatsapp"></i>
                          </div>
                          <span className="txt">
                            +91 {webSetupData.whatsapp}
                          </span>
                        </a>
                      </li>
                    )}
                    {webSetupData.email && (
                      <li>
                        <a href="mailto:inquiry@biznie.com">
                          <div className="icon">
                            <i className="bi bi-envelope"></i>
                          </div>
                          <span className="txt">{webSetupData.email}</span>
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
